import FullViewDialog from './FullViewDialog';

export default FullViewDialog;
